import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight, CheckCircle, Clock, Headphones } from 'lucide-react'

const CTASection = () => {
  const benefits = [
    {
      icon: Clock,
      title: 'Implementação em 7 dias',
      description: 'Nossa equipe especializada implementa tudo rapidamente'
    },
    {
      icon: Headphones,
      title: 'Suporte 24/7',
      description: 'Estamos sempre disponíveis para ajudar você'
    },
    {
      icon: CheckCircle,
      title: 'Sem contrato de fidelidade',
      description: 'Comece quando quiser, cancele quando quiser'
    }
  ]

  return (
    <section className="py-20 bg-gradient-to-br from-primary-600 via-primary-700 to-secondary-600 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mb-12"
          >
            <h2 className="text-3xl lg:text-5xl font-bold mb-6">
              Pronto para transformar sua escola de natação?
            </h2>
            <p className="text-xl text-primary-100 leading-relaxed">
              Junte-se a mais de 150 escolas que já estão usando nossa solução 
              para modernizar suas operações e aumentar suas receitas.
            </p>
          </motion.div>

          {/* Benefits */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
          >
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 rounded-2xl mb-4">
                  <benefit.icon className="h-8 w-8" />
                </div>
                <h3 className="text-lg font-semibold mb-2">
                  {benefit.title}
                </h3>
                <p className="text-primary-100">
                  {benefit.description}
                </p>
              </div>
            ))}
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link 
              to="/contato" 
              className="bg-white text-primary-600 hover:bg-gray-100 font-semibold py-4 px-8 rounded-lg transition-colors duration-200 inline-flex items-center justify-center"
            >
              Solicitar Demo Gratuito
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
            
            <Link 
              to="/apps" 
              className="border-2 border-white text-white hover:bg-white hover:text-primary-600 font-semibold py-4 px-8 rounded-lg transition-colors duration-200 inline-flex items-center justify-center"
            >
              Conhecer os Apps
            </Link>
          </motion.div>

          {/* Trust Indicators */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 pt-8 border-t border-white/20"
          >
            <p className="text-primary-100 text-sm">
              ✓ Teste gratuito por 14 dias • ✓ Sem cartão de crédito • ✓ Cancelamento a qualquer momento
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default CTASection
